import { useCallback, useEffect, useRef, useState } from 'react';

export const defaultTimer = 125;
export const useTimer = ({
  countdownFrom = defaultTimer,
  alarmHandler = undefined as (() => void) | undefined,
} = {}) => {
  const [time, setTime] = useState(countdownFrom);
  const intervalRef = useRef<number | null>(null);

  const handleTimerStop = useCallback(() => {
    if (intervalRef.current !== null) {
      window.clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []); // No need to depend on countdownFrom here

  useEffect(() => {
    if (time > 0) return;
    const handleExpired = () => {
      if (alarmHandler && intervalRef.current !== null) {
        alarmHandler();
        handleTimerStop();
      }
    };
    handleExpired();
  }, [alarmHandler, handleTimerStop, time]);

  useEffect(() => {
    return () => {
      handleTimerStop();
    };
  }, [handleTimerStop]);

  const handleTimerStart = useCallback(() => {
    handleTimerStop();
    setTime(countdownFrom);
    intervalRef.current = window.setInterval(() => {
      setTime(t => Math.max(t - 1, 0)); // Prevent negative time
    }, 1000);
  }, [countdownFrom, handleTimerStop]);

  return {
    handleTimerStart,
    handleTimerStop,
  };
};
